<section class="l-reset">
  <div class="reset">
    <a routerLink="/auth" class="reset-backLink login-header-backLink">
      {{ "Go back" | translate }}

      <img src="/assets/images/login/header-back-btn.png" alt="" class="icon" />
    </a>

    <div class="reset-body">
      <div class="reset-cover">
        <img
          src="/assets/images/login/reset-change-password.png"
          alt=""
          class="image"
        />
      </div>
      <h2 class="reset-title">
        {{ "change Password" | translate }}
      </h2>
      <p class="reset-desc">
        {{ "Please choose a strong and memorable password" | translate }}
      </p>

      <form [formGroup]="changePasswordForm">
        <div class="form-group">
          <app-evento-input
            [eventoFormControl]="changePasswordForm.get('password')"
            type="password"
            requiredMessage="{{ 'Required Field' | translate }}"
            minlengthMessage="{{
              'Min Length Field' | translate : { value: '6' }
            }}"
            placeholder="{{ 'new password' | translate }}"
          ></app-evento-input>
        </div>
        <div class="form-group">
          <app-evento-input
            [eventoFormControl]="changePasswordForm.get('confirmPassword')"
            type="password"
            minlengthMessage="{{
              'Min Length Field' | translate : { value: '6' }
            }}"
            requiredMessage="{{ 'Required Field' | translate }}"
            mustMatchMessage="{{ 'Not Matched' | translate }}"
            placeholder="{{ 'Confirm the new password' | translate }}"
          ></app-evento-input>
        </div>
      </form>

      <button
        type="button"
        (click)="changePassword()"
        [disabled]="changePasswordForm.invalid"
        class="btn btn-primary w-100 mb-3"
      >
        {{ "Save" | translate }}
      </button>
    </div>
  </div>
</section>
